<template>
  <div class="user-wrapper">
    <!-- <a-dropdown v-if="isMobile()" v-model="visible" :placement="placement">
      <span class="action">
        <a-icon type="ellipsis" style="font-size: 16px" />
      </span>
      <a-menu slot="overlay" @click="handleMenuClick">
        <a-menu-item key="1" @click="toHelp">
          <a-icon type="question-circle-o" style="font-size: 16px" />
          帮助
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <template v-else>
      <span class="action" @click="toHelp">
        <a-icon type="question-circle-o" style="font-size: 16px" />
      </span>
    </template> -->
    <div class="random-content">
      <span>{{ getRandomStr }}</span>
    </div>
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar
          class="avatar"
          size="small"
          style="color: #fff; background: #ccc"
          :src="avatar() || require('@/assets/avatar2.jpg')"
        />
        <span>{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
        <a-menu-item key="1">
          <router-link :to="{ name: 'BaseSettings' }">
            <a-icon type="setting" />
            <span>个人设置</span>
          </router-link>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item key="3">
          <a href="javascript:;" @click="handleLogout">
            <a-icon type="logout" />
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { handleErrs } from "@/utils/errors";
import moment from "moment";
import { mixin, mixinDevice } from "@/utils/mixin.js";

const statusMap = {
  0: {
    text: "未开始",
    style: "normal",
  },
  1: {
    text: "进行中",
    style: "active",
  },
  2: {
    text: "成功",
    style: "success",
  },
  3: {
    text: "失败",
    style: "exception",
  },
};

export default {
  name: "UserMenu",
  mixins: [mixin, mixinDevice],
  data() {
    return {
      visible: false,
      placement: "bottomRight",
      exportTaskData: [
        {
          status: 0,
          tag: "D批名单",
          percentage: 0,
          create_time: "2020-2-20 18:33:58",
        },
        {
          status: 1,
          tag: "C批名单",
          percentage: 50,
          create_time: "2020-2-20 18:20:58",
        },
      ],
    };
  },
  computed: {
    //显示四位随机码
    getRandomStr() {
      const date = this.moment().format("YYYY-MM-dd");
      var str = this.$md5(date.toString());
      var result = str.substr(0, 2) + str.substr(-2, 2);
      return result;
    },
  },
  filters: {
    textFilter(num) {
      return statusMap[num].text;
    },
    styleFilter(num) {
      return statusMap[num].style;
    },
  },
  methods: {
    moment,
    ...mapActions(["Logout", "setImportTaskID"]),
    ...mapGetters(["nickname", "avatar"]),
    toHelp() {
      window.open("https://www.kancloud.cn/cdqidian/help/1783059");
    },

    handleMenuClick(e) {
      if (e.key === "1") {
        this.visible = false;
      }
    },
    openNotification(success) {
      const key = `open${Date.now()}`;
      this.$notification.open({
        message: success ? "导入成功" : "导入失败",
        description: "点击查看按钮进入详情页面",
        duration: 0,
        icon: success ? (
          <a-icon type="check-circle" style="color:#52c41a" />
        ) : (
          <a-icon type="close-circle" style="color:#f5222d" />
        ),
        btn: (h) => {
          return h(
            "a-button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              on: {
                click: () => {
                  this.jumpTaskDetail();
                  this.$notification.close(key);
                },
              },
            },
            "查看"
          );
        },
        key,
        onClose: close,
      });
    },
    deleteID(ids, id) {
      let arr = ids.split(",");
      var index = arr.indexOf(id);
      arr.splice(index, 1);
      return arr.join(",");
    },
    getImportTaskData() {
      setInterval(() => {
        const _this = this;
        const { importTaskID } = _this.$store.state.task;
        if (!importTaskID) {
          _this.importTaskData = [];
          return;
        }
        const params = {
          id__in: importTaskID,
        };
        getImportTask(params)
          .then((res) => {
            _this.importTaskData = res.data;
            let ids = importTaskID;
            _this.importTaskData.forEach((item) => {
              if (item.status == 3) {
                _this.openNotification(false);
                ids = _this.deleteID(ids, item.id);
              } else if (item.status == 2) {
                _this.openNotification(true);
                ids = _this.deleteID(ids, item.id);
              }
            });
            _this.setImportTaskID(ids);
          })
          .catch((err) => {});
      }, 10000);
    },
    handleLogout() {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return _this
            .Logout({})
            .then(() => {
              window.location.reload();
            })
            .catch((err) => {
              _this.$notification['error']({
                message: '错误',
                description: '退出登录时，发生错误'
              })
            });
          // sessionStorage.removeItem("user");
          // _this.$router.push("/login");
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.random-content {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  margin-right: 60px;
  span {
    border: 1px solid #1890ff;
    color: #1890ff;
    padding: 12px 18px;
    border-radius: 10px;
  }
}
.ant-comment {
  /deep/ .ant-comment-inner {
    padding: 0;
    width: 200px;
    rgb(158, 158, 158) .ant-comment-avatar {
      margin-right: 0;
    }
    .ant-comment-content-author {
      margin-bottom: 0;
    }
    .ant-comment-actions {
      margin-top: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Tools/UserMenu.vue